import { useLocalStorage } from "primereact/hooks";
import React,{useEffect, useRef, useState} from "react";
import func from "./services/functions";
import mainAxios from "./services/mainAxios";
import i18next from "i18next";
import moment from "moment";

export const usePersistedState = (defaultValue, key) => {
  const value = JSON.parse(localStorage.getItem(key));
  const [state, setState] = React.useState(
    value === "" ? value : value || defaultValue,
    key
  );
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  const resetSate = () => setState(defaultValue);
  return [state, setState, resetSate];
};

export const AppContext = React.createContext(null);

export const useAppContext = () => React.useContext(AppContext);

let store;

export const getStore = () => ({ ...store });

export const AppContextProvider = ({ children }) => {
  const forbidden = useState(false);
  const company = useState(null);
  const user = usePersistedState(null, "user");
  const settings = usePersistedState(null, "userSettings");
  const selectedCompany = usePersistedState(null, "selectedCompany");
  const queueColumns = usePersistedState(null, "queueColumns");
  const purchasesColumns = usePersistedState(null, "purchaseColumns")
  const [unitsOfMeasure,setUnitsOfMeasure] = React.useState([])
  const [unitOfmeasureLoading,setUnitOfmeasureLoading] = React.useState(false)
  const sessionWindow=useRef(null)
  const [invoice, setInvoice] = useState(null);
  const sideBarExpanded = usePersistedState({hover:true,show:true},'SideBarExpanded');
  const notificationsRefresh=useState(false)
  const reloadData = useState([])
  const [refreshStatuses, setRefreshStatuses] = useState([]);
  const fullCompany=company[0]
  const defaultUomPagination={
    totalRows: 0,
    pageSize: 30,
    pageNumber: 1,
}
  const [disabledLayout, setDisabledLayout] = useState(false);

  const [uomPagination,setUomPagination]=useState(defaultUomPagination)

  const customInvoiceColumns = usePersistedState(
    [
      "issueDate",
      "invoiceTypeIcons",
      "recordDate",
      "businessUnitCode",
      "tcrCode",
      "internalId",
      "iic",
      "buyer",
      "seller",
      "status",
      "type",
      "invoiceTotalWithVat",
      "invoiceTotalWithVatALL",
      "currency",
      "actions",
    ],
    "customInvoiceColumns"
  );

  const cisColumns = usePersistedState(null, "cisColumns");

  const wtnColumns = usePersistedState(null, "wtnColumns1");
  const socketRef = React.useState(null);
  const dates=React.useState({
    fromDate: func.getDateFromToday(-2),
    toDate: func.getDateFromToday(1)
  })



  const getUnitOfmeasure=({pageSize=defaultUomPagination.pageSize, pageNumber = defaultUomPagination.pageNumber,searchQuery,loadMore,noPagination=false}={})=>{
    if(!noPagination) setUnitOfmeasureLoading(true)
    return mainAxios
      .post("apiEndpoint/search", {
        object: "GetUnitOfMeasure",
        value: "",
        params:{
          unitOfMeasureLiveSearch:searchQuery
        },
        sortCriteria : [{
          field: "priority",
          direction: "ASC"
        }],
        pagination:noPagination?null:{
          pageSize,
          pageNumber,
      },
      })
      .then((res) => {
        if (res?.data?.status) {
          if(noPagination){
            return res.data.content
          }
          let data = res.data?.content.filter((uom) => uom?.showInFront == null || uom?.showInFront == true) ?? []
          setUomPagination((pagination)=>({...pagination,pageNumber,pageSize,totalRows:res?.data?.totalSize}))
          setUnitsOfMeasure((uoms)=>loadMore?uoms.concat(data):data);
        }
        if(!noPagination) setUnitOfmeasureLoading(false)
      }).catch((err) => {
        if(!noPagination) setUnitOfmeasureLoading(false)
      })
  }

  const getStatus = () => {
    mainAxios
      .post("apiEndpoint/search", {
        object: "GetInvoicesResendStatuses",
        value: null,
      })
      .then((res) => {
        if (res) {
          setRefreshStatuses(res?.data?.content);
        }
      });
  };
  
  const getCompany=(companyId)=>{
    const setFullCompany=company[1]
    const currentUser = user[0]
    const companyIdToUse = companyId ?? selectedCompany[0]
    mainAxios.post('apiEndpoint/search', {
        object: "GetCompany",
        noWrapperData: true,
        company: companyIdToUse,
        username: currentUser?.username,
        params: JSON.stringify({
            id: companyIdToUse
        })
    }).then(res => {
        if(res?.data?.status) {
            setFullCompany(res?.data?.content[0])
        }
    })
}

  const getUser=()=>{
    let [currentUser,setCurrentUser]=user
    mainAxios
    .post("apiEndpoint/search",
      {
        object: "GetUser",
        value: null,
        type: "basic",
        params: { username:currentUser.username },
      },
    )
    .then((res) => {
      if (res && res.data?.content?.[0]) {
        let fullUser = res.data.content[0];
        if (
          !fullUser.companiesRights.find(
            (company) => company.id === parseInt(selectedCompany[0])
          )
        ) {
          setCurrentUser(null);
        } else {
          delete res.data.content[0]["companyBranchesTcr"];
          setCurrentUser(fullUser);
        }
      }
    });
  }

  const applySettings = (data) => {
    settings[1](data);
    if (data?.language && data.language !== i18next.language) {
      i18next.changeLanguage(data.language);
      localStorage.setItem("language", data.language);
    }
    if (data?.sidebar) {
      sideBarExpanded[1]((prev) => ({ ...prev, ...data.sidebar }));
    }
  }

  const getSettings = () => {
    return mainAxios
      .get("/endpoint/v2/settings", { showErrorToast: false })
      .then((res) => {
        if (res?.data) {
          applySettings(res.data);
        }
        return res?.data ?? null;
      })
      .catch((error) => {
        console.warn("Failed to load user settings", error);
        return null;
      });
  }

  const saveLanguage = (language) => {
    if (!language || !user[0]) return Promise.resolve(null);
    return mainAxios
      .patch("/endpoint/v2/settings/language", {
        noWrapperData: true,
        language,
      }, { showErrorToast: false })
      .then((res) => {
        if (res?.data) {
          settings[1](res.data);
        }
        return res?.data;
      })
      .catch((error) => {
        console.warn("Failed to save language setting", error);
        return null;
      });
  }

  const saveSidebar = (sidebar) => {
    if (!sidebar || !user[0]) return Promise.resolve(null);
    const payload = { show: !!sidebar.show, hover: !!sidebar.hover };
    const storeResponse = (res) => {
      if (res?.data) {
        settings[1](res.data);
      }
      return res?.data;
    };
    return mainAxios
      .patch("/endpoint/v2/settings/sidebar", {
        noWrapperData: true,
        sidebar: payload,
      }, { showErrorToast: false })
      .then(storeResponse)
      .catch((error) => {
        const status = error?.response?.status;
        console.warn("Sidebar PATCH failed with status", status, "- falling back to PUT /settings");
        const currentSettings = settings[0];
        if (currentSettings) {
          return mainAxios
            .put("/endpoint/v2/settings", {
              noWrapperData: true,
              language: currentSettings.language ?? i18next.language ?? "alb",
              sidebar: payload,
              gridPreferences: currentSettings.gridPreferences ?? {},
            }, { showErrorToast: false })
            .then(storeResponse)
            .catch((putError) => {
              console.warn("Failed to save sidebar setting", putError);
              return null;
            });
        }
        console.warn("Failed to save sidebar setting", error);
        return null;
      });
  }

  const settingsUsernameRef = useRef(null)
  const currentUsername = user[0]?.username ?? null
  useEffect(() => {
    if (!currentUsername) {
      settingsUsernameRef.current = null
      return
    }
    if (settingsUsernameRef.current === currentUsername) return
    settingsUsernameRef.current = currentUsername
    getSettings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUsername])

  const saveGridPreference = (gridKey, columns) => {
    if (!gridKey || !columns || !user[0]) return Promise.resolve(null);
    return mainAxios
      .patch(`/endpoint/v2/settings/grid/${gridKey}`, {
        noWrapperData: true,
        columns,
      }, { showErrorToast: false })
      .then((res) => {
        if (res?.data) {
          settings[1](res.data);
        }
        return res?.data;
      })
      .catch((error) => {
        console.warn("Failed to save grid preference", gridKey, error);
        return null;
      });
  }

  store = {
    user,
    settings,
    getSettings,
    saveGridPreference,
    saveLanguage,
    saveSidebar,
    selectedCompany,
    queueColumns,
    customInvoiceColumns,
    purchasesColumns,
    wtnColumns,
    socketRef,
    cisColumns,
    forbidden,
    company,
    dates,
    getCompany,
    reloadData,
    unitsOfMeasure,
    setUnitsOfMeasure,
    unitOfmeasureLoading,
    setUnitOfmeasureLoading,
    getUnitOfmeasure,
    uomPagination,
    setUomPagination,
    sessionWindow,
    invoice,
    setInvoice,
    getUser,
    notificationsRefresh,
    sideBarExpanded,
    getStatus,
    refreshStatuses,
    setRefreshStatuses,
    disabledLayout,
    setDisabledLayout
  };

  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};
